import { borderColor, primaryColor } from "../colors";

export const tableStyles = {
  bgColor: "#fff",
  borderWidth: "1px",
  borderColor: borderColor,
  borderRadius: "12px",
  padding: "12px",
};

export const cellStyles = {
  p: "0",
  fontSize: "sm",
};

export const cellStylesChangeColor = {
  py: "16px",
  px: "24px",
  fontSize: "sm",
  backgroundColor: "gray.200",
};

export const headerCellStyles = {
  px: "24px",
  fontSize: "xs",
  fontWeight: "bold",
  color: "#000",
  border: "0",
  whiteSpace: "normal",
};

export const headerCellTagStyles = {
  fontSize: "xs",
  fontWeight: "bold",
  color: "white",
  border: "0",
  whiteSpace: "normal",
  backgroundColor: primaryColor,
};

export const fixedColumnStyle = {
  position: "sticky",
  zIndex: 1,
  backgroundColor: "white",
};

export const fixedColumnShadow = {
  boxShadow: "-10px 0px 6px 0px rgba(0, 0, 0, 0.05)",
};

export const tableInput = {
  height: "25px",
};

export const paginationButtons = {
  height: "46px",
  width: "46px",
  border: "0px",
  borderRadius: "0",
  padding: "12px",
  fontWeight: "bold",
};

export const paginationSelect = {
  borderRadius: "4",
  color: "#4A5568",
  height: "46px",
  width: "90px",
};
